import { Section } from '@policygenius/dif-ts-types';

const schema: Section = {
  nodeType: 'SECTION',
  urn: 'urn:pg:interview:section:continue-online-substance-use',
  content: '',
  rules: { operation: '=', field: 'children.all.valid', value: true },
  presentationRules: {
    question_insured_risk_condition_drinks_alcohol_quantity_per_week: {
      field: 'question_insured_risk_condition_drinks_alcohol.value',
      value: true,
      operation: '=',
    },
    question_insured_risk_condition_alcohol_treatment_date: {
      field: 'question_insured_risk_condition_alcohol_treatment.value',
      value: true,
      operation: '=',
    },
    question_insured_risk_condition_drug_treatment_date: {
      field: 'question_insured_risk_condition_drug_treatment.value',
      value: true,
      operation: '=',
    },
  },
  children: [
    {
      nodeType: 'QUESTION',
      urn: 'urn:pg:interview:question:insured-risk-condition-drinks-alcohol',
      questionType: 'BOOLEAN',
      content: 'Do you drink alcohol?',
      dataPoint: {
        dataType: 'boolean',
        urn: 'urn:pg:data-point:insured-risk-condition-drinks-alcohol',
      },
      rules: { field: 'value.present', value: true, operation: '=' },
    },
    {
      nodeType: 'QUESTION',
      urn: 'urn:pg:interview:question:insured-risk-condition-drinks-alcohol-quantity-per-week',
      questionType: 'NUMBER',
      content: 'On average, how many alcoholic beverages do you consume per week?',
      helpText: 'If your frequency is less than weekly, please enter 1',
      dataPoint: {
        dataType: 'integer',
        urn: 'urn:pg:data-point:insured-risk-condition-drinks-alcohol-quantity-per-week',
      },
      rules: {
        field: 'value',
        value: 1,
        operation: '>=',
      },
    },
    {
      nodeType: 'QUESTION',
      urn: 'urn:pg:interview:question:insured-risk-condition-alcohol-treatment',
      questionType: 'BOOLEAN',
      dataPoint: {
        dataType: 'boolean',
        urn: 'urn:pg:data-point:insured-risk-condition-alcohol-treatment',
      },
      content: 'Have you ever been treated for alcohol abuse?',
      rules: { field: 'value.present', value: true, operation: '=' },
    },
    {
      nodeType: 'QUESTION',
      urn: 'urn:pg:interview:question:insured-risk-condition-alcohol-treatment-date',
      questionType: 'DATE',
      dataPoint: {
        dataType: 'date',
        urn: 'urn:pg:data-point:insured-risk-condition-alcohol-treatment-date',
      },
      content: 'When was your most recent treatment?',
      rules: { field: 'value.present', value: true, operation: '=' },
    },
    {
      nodeType: 'QUESTION',
      urn: 'urn:pg:interview:question:insured-risk-condition-drug-treatment',
      questionType: 'BOOLEAN',
      dataPoint: {
        dataType: 'boolean',
        urn: 'urn:pg:data-point:insured-risk-condition-drug-treatment',
      },
      content: 'Have you ever been treated for drug abuse?',
      rules: { field: 'value.present', value: true, operation: '=' },
    },
    {
      nodeType: 'QUESTION',
      urn: 'urn:pg:interview:question:insured-risk-condition-drug-treatment-date',
      questionType: 'DATE',
      dataPoint: {
        dataType: 'date',
        urn: 'urn:pg:data-point:insured-risk-condition-drug-treatment-date',
      },
      content: 'When was your most recent treatment?',
      rules: { field: 'value.present', value: true, operation: '=' },
    },
  ],
};

// LIFE-3224 - Remove if Funnel Remix loses
export const funnelRemixSchema: Section = {
  ...schema,
  children: [
    {
      nodeType: 'QUESTION',
      questionType: 'BOOLEAN',
      content: 'Have you ever used any marijuana products?',
      dataPoint: {
        dataType: 'boolean',
        urn: 'urn:pg:data-point:insured-risk-condition-marijuana',
      },
      urn: 'urn:pg:interview:question:insured-risk-condition-marijuana',
      rules: {
        field: 'value.present',
        value: true,
        operation: '=',
      },
    },
    ...schema.children,
  ],
};

export default schema;
